export default {
  "1912": {
    "month": {
      "1": 20,
      "2": 51,
      "3": 20,
      "4": 51,
      "5": 21,
      "6": 52,
      "7": 22,
      "8": 53,
      "9": 24,
      "10": 54,
      "11": 25,
      "12": 55
    }
  },
  "1913": {
    "month": {
      "1": 26,
      "2": 57,
      "3": 25,
      "4": 56,
      "5": 26,
      "6": 57,
      "7": 27,
      "8": 58,
      "9": 29,
      "10": 59,
      "11": 30,
      "12": 60
    }
  },
  "1914": {
    "month": {
      "1": 31,
      "2": 62,
      "3": 30,
      "4": 61,
      "5": 31,
      "6": 62,
      "7": 32,
      "8": 63,
      "9": 34,
      "10": 64,
      "11": 35,
      "12": 65
    }
  },
  "1915": {
    "month": {
      "1": 36,
      "2": 67,
      "3": 35,
      "4": 66,
      "5": 36,
      "6": 67,
      "7": 37,
      "8": 8,
      "9": 39,
      "10": 9,
      "11": 40,
      "12": 10
    }
  },
  "1916": {
    "month": {
      "1": 41,
      "2": 12,
      "3": 41,
      "4": 12,
      "5": 42,
      "6": 13,
      "7": 43,
      "8": 14,
      "9": 45,
      "10": 15,
      "11": 46,
      "12": 16
    }
  },
  "1917": {
    "month": {
      "1": 47,
      "2": 18,
      "3": 46,
      "4": 17,
      "5": 47,
      "6": 18,
      "7": 48,
      "8": 19,
      "9": 50,
      "10": 20,
      "11": 51,
      "12": 21
    }
  },
  "1918": {
    "month": {
      "1": 52,
      "2": 23,
      "3": 51,
      "4": 22,
      "5": 52,
      "6": 23,
      "7": 53,
      "8": 24,
      "9": 55,
      "10": 24,
      "11": 26,
      "12": 26
    }
  },
  "1919": {
    "month": {
      "1": 57,
      "2": 28,
      "3": 56,
      "4": 27,
      "5": 57,
      "6": 28,
      "7": 58,
      "8": 29,
      "9": 60,
      "10": 30,
      "11": 61,
      "12": 31
    }
  },
  "1920": {
    "month": {
      "1": 62,
      "2": 33,
      "3": 62,
      "4": 33,
      "5": 63,
      "6": 34,
      "7": 64,
      "8": 35,
      "9": 66,
      "10": 36,
      "11": 67,
      "12": 37
    }
  },
  "1921": {
    "month": {
      "1": 68,
      "2": 39,
      "3": 67,
      "4": 38,
      "5": 68,
      "6": 39,
      "7": 9,
      "8": 40,
      "9": 11,
      "10": 41,
      "11": 12,
      "12": 42
    }
  },
  "1922": {
    "month": {
      "1": 13,
      "2": 44,
      "3": 12,
      "4": 43,
      "5": 13,
      "6": 44,
      "7": 14,
      "8": 45,
      "9": 16,
      "10": 46,
      "11": 17,
      "12": 47
    }
  },
  "1923": {
    "month": {
      "1": 18,
      "2": 50,
      "3": 17,
      "4": 48,
      "5": 18,
      "6": 49,
      "7": 19,
      "8": 50,
      "9": 21,
      "10": 51,
      "11": 22,
      "12": 52
    }
  },
  "1924": {
    "month": {
      "1": 23,
      "2": 54,
      "3": 23,
      "4": 54,
      "5": 24,
      "6": 55,
      "7": 25,
      "8": 56,
      "9": 27,
      "10": 57,
      "11": 28,
      "12": 58
    }
  },
  "1925": {
    "month": {
      "1": 29,
      "2": 60,
      "3": 28,
      "4": 59,
      "5": 29,
      "6": 60,
      "7": 30,
      "8": 61,
      "9": 32,
      "10": 62,
      "11": 33,
      "12": 63
    }
  },
  "1926": {
    "month": {
      "1": 34,
      "2": 65,
      "3": 33,
      "4": 64,
      "5": 34,
      "6": 65,
      "7": 35,
      "8": 66,
      "9": 37,
      "10": 67,
      "11": 38,
      "12": 68
    }
  },
  "1927": {
    "month": {
      "1": 39,
      "2": 10,
      "3": 38,
      "4": 9,
      "5": 39,
      "6": 10,
      "7": 40,
      "8": 11,
      "9": 42,
      "10": 12,
      "11": 43,
      "12": 13
    }
  },
  "1928": {
    "month": {
      "1": 44,
      "2": 15,
      "3": 44,
      "4": 15,
      "5": 45,
      "6": 16,
      "7": 46,
      "8": 17,
      "9": 48,
      "10": 18,
      "11": 49,
      "12": 19
    }
  },
  "1929": {
    "month": {
      "1": 50,
      "2": 21,
      "3": 49,
      "4": 20,
      "5": 50,
      "6": 21,
      "7": 51,
      "8": 22,
      "9": 53,
      "10": 23,
      "11": 54,
      "12": 24
    }
  },
  "1930": {
    "month": {
      "1": 55,
      "2": 26,
      "3": 54,
      "4": 25,
      "5": 55,
      "6": 26,
      "7": 56,
      "8": 27,
      "9": 58,
      "10": 28,
      "11": 59,
      "12": 29
    }
  },
  "1931": {
    "month": {
      "1": 60,
      "2": 31,
      "3": 59,
      "4": 30,
      "5": 60,
      "6": 31,
      "7": 61,
      "8": 32,
      "9": 63,
      "10": 33,
      "11": 64,
      "12": 34
    }
  },
  "1932": {
    "month": {
      "1": 65,
      "2": 36,
      "3": 65,
      "4": 36,
      "5": 66,
      "6": 37,
      "7": 67,
      "8": 38,
      "9": 9,
      "10": 39,
      "11": 10,
      "12": 40
    }
  },
  "1933": {
    "month": {
      "1": 11,
      "2": 42,
      "3": 10,
      "4": 41,
      "5": 11,
      "6": 42,
      "7": 12,
      "8": 43,
      "9": 14,
      "10": 44,
      "11": 15,
      "12": 45
    }
  },
  "1934": {
    "month": {
      "1": 16,
      "2": 47,
      "3": 15,
      "4": 46,
      "5": 16,
      "6": 47,
      "7": 17,
      "8": 48,
      "9": 19,
      "10": 49,
      "11": 20,
      "12": 50
    }
  },
  "1935": {
    "month": {
      "1": 21,
      "2": 52,
      "3": 20,
      "4": 51,
      "5": 21,
      "6": 52,
      "7": 22,
      "8": 53,
      "9": 24,
      "10": 54,
      "11": 25,
      "12": 55
    }
  },
  "1936": {
    "month": {
      "1": 26,
      "2": 57,
      "3": 26,
      "4": 57,
      "5": 27,
      "6": 58,
      "7": 28,
      "8": 59,
      "9": 30,
      "10": 60,
      "11": 31,
      "12": 61
    }
  },
  "1937": {
    "month": {
      "1": 32,
      "2": 63,
      "3": 31,
      "4": 62,
      "5": 32,
      "6": 63,
      "7": 33,
      "8": 64,
      "9": 35,
      "10": 65,
      "11": 36,
      "12": 66
    }
  },
  "1938": {
    "month": {
      "1": 37,
      "2": 68,
      "3": 36,
      "4": 67,
      "5": 37,
      "6": 68,
      "7": 38,
      "8": 9,
      "9": 40,
      "10": 10,
      "11": 41,
      "12": 11
    }
  },
  "1939": {
    "month": {
      "1": 42,
      "2": 13,
      "3": 41,
      "4": 12,
      "5": 42,
      "6": 13,
      "7": 43,
      "8": 14,
      "9": 45,
      "10": 15,
      "11": 46,
      "12": 16
    }
  },
  "1940": {
    "month": {
      "1": 47,
      "2": 18,
      "3": 47,
      "4": 18,
      "5": 48,
      "6": 19,
      "7": 49,
      "8": 20,
      "9": 51,
      "10": 21,
      "11": 52,
      "12": 22
    }
  },
  "1941": {
    "month": {
      "1": 53,
      "2": 24,
      "3": 52,
      "4": 23,
      "5": 53,
      "6": 24,
      "7": 54,
      "8": 25,
      "9": 56,
      "10": 26,
      "11": 57,
      "12": 27
    }
  },
  "1942": {
    "month": {
      "1": 58,
      "2": 29,
      "3": 57,
      "4": 28,
      "5": 58,
      "6": 29,
      "7": 59,
      "8": 30,
      "9": 61,
      "10": 31,
      "11": 62,
      "12": 32
    }
  },
  "1943": {
    "month": {
      "1": 63,
      "2": 34,
      "3": 62,
      "4": 33,
      "5": 63,
      "6": 34,
      "7": 64,
      "8": 35,
      "9": 66,
      "10": 36,
      "11": 67,
      "12": 37
    }
  },
  "1944": {
    "month": {
      "1": 68,
      "2": 39,
      "3": 68,
      "4": 39,
      "5": 9,
      "6": 40,
      "7": 10,
      "8": 41,
      "9": 12,
      "10": 42,
      "11": 13,
      "12": 43
    }
  },
  "1945": {
    "month": {
      "1": 14,
      "2": 45,
      "3": 13,
      "4": 44,
      "5": 14,
      "6": 45,
      "7": 15,
      "8": 46,
      "9": 17,
      "10": 47,
      "11": 18,
      "12": 48
    }
  },
  "1946": {
    "month": {
      "1": 19,
      "2": 50,
      "3": 18,
      "4": 49,
      "5": 19,
      "6": 50,
      "7": 20,
      "8": 51,
      "9": 22,
      "10": 52,
      "11": 23,
      "12": 53
    }
  },
  "1947": {
    "month": {
      "1": 24,
      "2": 55,
      "3": 23,
      "4": 54,
      "5": 24,
      "6": 55,
      "7": 25,
      "8": 56,
      "9": 27,
      "10": 57,
      "11": 28,
      "12": 58
    }
  },
  "1948": {
    "month": {
      "1": 29,
      "2": 60,
      "3": 29,
      "4": 60,
      "5": 30,
      "6": 61,
      "7": 31,
      "8": 62,
      "9": 33,
      "10": 63,
      "11": 34,
      "12": 64
    }
  },
  "1949": {
    "month": {
      "1": 35,
      "2": 66,
      "3": 34,
      "4": 65,
      "5": 35,
      "6": 66,
      "7": 36,
      "8": 67,
      "9": 38,
      "10": 68,
      "11": 39,
      "12": 9
    }
  },
  "1950": {
    "month": {
      "1": 40,
      "2": 11,
      "3": 39,
      "4": 10,
      "5": 40,
      "6": 11,
      "7": 41,
      "8": 12,
      "9": 43,
      "10": 13,
      "11": 44,
      "12": 14
    }
  },
  "1951": {
    "month": {
      "1": 45,
      "2": 16,
      "3": 44,
      "4": 15,
      "5": 45,
      "6": 16,
      "7": 46,
      "8": 17,
      "9": 48,
      "10": 18,
      "11": 49,
      "12": 19
    }
  },
  "1952": {
    "month": {
      "1": 50,
      "2": 21,
      "3": 50,
      "4": 21,
      "5": 51,
      "6": 22,
      "7": 52,
      "8": 23,
      "9": 54,
      "10": 24,
      "11": 55,
      "12": 25
    }
  },
  "1953": {
    "month": {
      "1": 56,
      "2": 27,
      "3": 55,
      "4": 26,
      "5": 56,
      "6": 27,
      "7": 57,
      "8": 28,
      "9": 59,
      "10": 29,
      "11": 60,
      "12": 30
    }
  },
  "1954": {
    "month": {
      "1": 61,
      "2": 32,
      "3": 60,
      "4": 31,
      "5": 61,
      "6": 32,
      "7": 62,
      "8": 33,
      "9": 64,
      "10": 34,
      "11": 65,
      "12": 35
    }
  },
  "1955": {
    "month": {
      "1": 66,
      "2": 37,
      "3": 65,
      "4": 36,
      "5": 66,
      "6": 37,
      "7": 67,
      "8": 38,
      "9": 9,
      "10": 39,
      "11": 10,
      "12": 40
    }
  },
  "1956": {
    "month": {
      "1": 11,
      "2": 42,
      "3": 11,
      "4": 42,
      "5": 12,
      "6": 43,
      "7": 13,
      "8": 44,
      "9": 15,
      "10": 45,
      "11": 16,
      "12": 46
    }
  },
  "1957": {
    "month": {
      "1": 17,
      "2": 48,
      "3": 16,
      "4": 47,
      "5": 17,
      "6": 48,
      "7": 18,
      "8": 49,
      "9": 20,
      "10": 50,
      "11": 21,
      "12": 51
    }
  },
  "1958": {
    "month": {
      "1": 22,
      "2": 53,
      "3": 21,
      "4": 52,
      "5": 22,
      "6": 53,
      "7": 23,
      "8": 54,
      "9": 25,
      "10": 55,
      "11": 26,
      "12": 56
    }
  },
  "1959": {
    "month": {
      "1": 27,
      "2": 58,
      "3": 26,
      "4": 57,
      "5": 27,
      "6": 58,
      "7": 28,
      "8": 59,
      "9": 30,
      "10": 60,
      "11": 31,
      "12": 61
    }
  },
  "1960": {
    "month": {
      "1": 32,
      "2": 63,
      "3": 32,
      "4": 63,
      "5": 33,
      "6": 64,
      "7": 34,
      "8": 65,
      "9": 36,
      "10": 66,
      "11": 37,
      "12": 67
    }
  },
  "1961": {
    "month": {
      "1": 38,
      "2": 9,
      "3": 37,
      "4": 68,
      "5": 38,
      "6": 9,
      "7": 39,
      "8": 20,
      "9": 41,
      "10": 11,
      "11": 42,
      "12": 12
    }
  },
  "1962": {
    "month": {
      "1": 43,
      "2": 14,
      "3": 42,
      "4": 13,
      "5": 43,
      "6": 14,
      "7": 44,
      "8": 15,
      "9": 46,
      "10": 16,
      "11": 47,
      "12": 17
    }
  },
  "1963": {
    "month": {
      "1": 48,
      "2": 19,
      "3": 47,
      "4": 18,
      "5": 48,
      "6": 19,
      "7": 49,
      "8": 20,
      "9": 51,
      "10": 21,
      "11": 52,
      "12": 22
    }
  },
  "1964": {
    "month": {
      "1": 53,
      "2": 24,
      "3": 53,
      "4": 24,
      "5": 54,
      "6": 25,
      "7": 55,
      "8": 26,
      "9": 57,
      "10": 27,
      "11": 58,
      "12": 28
    }
  },
  "1965": {
    "month": {
      "1": 59,
      "2": 30,
      "3": 58,
      "4": 29,
      "5": 59,
      "6": 30,
      "7": 60,
      "8": 31,
      "9": 62,
      "10": 32,
      "11": 63,
      "12": 33
    }
  },
  "1966": {
    "month": {
      "1": 64,
      "2": 35,
      "3": 63,
      "4": 34,
      "5": 64,
      "6": 35,
      "7": 65,
      "8": 36,
      "9": 67,
      "10": 37,
      "11": 68,
      "12": 38
    }
  },
  "1967": {
    "month": {
      "1": 9,
      "2": 40,
      "3": 68,
      "4": 39,
      "5": 9,
      "6": 40,
      "7": 10,
      "8": 41,
      "9": 12,
      "10": 42,
      "11": 13,
      "12": 43
    }
  },
  "1968": {
    "month": {
      "1": 14,
      "2": 45,
      "3": 14,
      "4": 45,
      "5": 15,
      "6": 46,
      "7": 16,
      "8": 47,
      "9": 18,
      "10": 48,
      "11": 19,
      "12": 49
    }
  },
  "1969": {
    "month": {
      "1": 20,
      "2": 51,
      "3": 19,
      "4": 50,
      "5": 20,
      "6": 51,
      "7": 21,
      "8": 52,
      "9": 23,
      "10": 53,
      "11": 24,
      "12": 54
    }
  },
  "1970": {
    "month": {
      "1": 25,
      "2": 56,
      "3": 24,
      "4": 55,
      "5": 25,
      "6": 56,
      "7": 26,
      "8": 57,
      "9": 28,
      "10": 58,
      "11": 29,
      "12": 59
    }
  },
  "1971": {
    "month": {
      "1": 30,
      "2": 61,
      "3": 29,
      "4": 60,
      "5": 30,
      "6": 61,
      "7": 31,
      "8": 62,
      "9": 33,
      "10": 63,
      "11": 34,
      "12": 64
    }
  },
  "1972": {
    "month": {
      "1": 35,
      "2": 66,
      "3": 35,
      "4": 66,
      "5": 36,
      "6": 67,
      "7": 37,
      "8": 68,
      "9": 39,
      "10": 9,
      "11": 40,
      "12": 10
    }
  },
  "1973": {
    "month": {
      "1": 41,
      "2": 12,
      "3": 40,
      "4": 11,
      "5": 41,
      "6": 12,
      "7": 42,
      "8": 13,
      "9": 44,
      "10": 14,
      "11": 45,
      "12": 15
    }
  },
  "1974": {
    "month": {
      "1": 46,
      "2": 17,
      "3": 45,
      "4": 16,
      "5": 46,
      "6": 17,
      "7": 47,
      "8": 18,
      "9": 49,
      "10": 19,
      "11": 50,
      "12": 20
    }
  },
  "1975": {
    "month": {
      "1": 51,
      "2": 22,
      "3": 50,
      "4": 21,
      "5": 51,
      "6": 22,
      "7": 52,
      "8": 23,
      "9": 54,
      "10": 24,
      "11": 55,
      "12": 25
    }
  },
  "1976": {
    "month": {
      "1": 56,
      "2": 27,
      "3": 56,
      "4": 27,
      "5": 57,
      "6": 28,
      "7": 58,
      "8": 29,
      "9": 60,
      "10": 30,
      "11": 61,
      "12": 31
    }
  },
  "1977": {
    "month": {
      "1": 62,
      "2": 33,
      "3": 61,
      "4": 32,
      "5": 62,
      "6": 33,
      "7": 63,
      "8": 30,
      "9": 65,
      "10": 35,
      "11": 66,
      "12": 36
    }
  },
  "1978": {
    "month": {
      "1": 67,
      "2": 38,
      "3": 66,
      "4": 37,
      "5": 67,
      "6": 38,
      "7": 8,
      "8": 39,
      "9": 10,
      "10": 40,
      "11": 11,
      "12": 41
    }
  },
  "1979": {
    "month": {
      "1": 12,
      "2": 43,
      "3": 11,
      "4": 42,
      "5": 12,
      "6": 43,
      "7": 13,
      "8": 44,
      "9": 15,
      "10": 45,
      "11": 16,
      "12": 46
    }
  },
  "1980": {
    "month": {
      "1": 17,
      "2": 48,
      "3": 17,
      "4": 48,
      "5": 18,
      "6": 49,
      "7": 19,
      "8": 50,
      "9": 21,
      "10": 51,
      "11": 22,
      "12": 52
    }
  },
  "1981": {
    "month": {
      "1": 23,
      "2": 54,
      "3": 22,
      "4": 53,
      "5": 23,
      "6": 54,
      "7": 24,
      "8": 55,
      "9": 26,
      "10": 56,
      "11": 27,
      "12": 57
    }
  },
  "1982": {
    "month": {
      "1": 28,
      "2": 59,
      "3": 27,
      "4": 58,
      "5": 28,
      "6": 59,
      "7": 29,
      "8": 60,
      "9": 31,
      "10": 61,
      "11": 32,
      "12": 62
    }
  },
  "1983": {
    "month": {
      "1": 33,
      "2": 64,
      "3": 32,
      "4": 63,
      "5": 33,
      "6": 64,
      "7": 34,
      "8": 65,
      "9": 36,
      "10": 66,
      "11": 37,
      "12": 67
    }
  },
  "1984": {
    "month": {
      "1": 38,
      "2": 9,
      "3": 38,
      "4": 9,
      "5": 39,
      "6": 10,
      "7": 40,
      "8": 11,
      "9": 42,
      "10": 12,
      "11": 43,
      "12": 13
    }
  },
  "1985": {
    "month": {
      "1": 44,
      "2": 15,
      "3": 43,
      "4": 14,
      "5": 44,
      "6": 15,
      "7": 45,
      "8": 16,
      "9": 47,
      "10": 17,
      "11": 48,
      "12": 18
    }
  },
  "1986": {
    "month": {
      "1": 49,
      "2": 20,
      "3": 48,
      "4": 19,
      "5": 49,
      "6": 20,
      "7": 50,
      "8": 21,
      "9": 52,
      "10": 22,
      "11": 53,
      "12": 23
    }
  },
  "1987": {
    "month": {
      "1": 54,
      "2": 25,
      "3": 53,
      "4": 24,
      "5": 54,
      "6": 25,
      "7": 55,
      "8": 26,
      "9": 57,
      "10": 27,
      "11": 58,
      "12": 28
    }
  },
  "1988": {
    "month": {
      "1": 59,
      "2": 30,
      "3": 59,
      "4": 30,
      "5": 60,
      "6": 31,
      "7": 61,
      "8": 32,
      "9": 63,
      "10": 33,
      "11": 64,
      "12": 34
    }
  },
  "1989": {
    "month": {
      "1": 65,
      "2": 36,
      "3": 64,
      "4": 35,
      "5": 65,
      "6": 36,
      "7": 66,
      "8": 37,
      "9": 8,
      "10": 38,
      "11": 9,
      "12": 39
    }
  },
  "1990": {
    "month": {
      "1": 10,
      "2": 41,
      "3": 9,
      "4": 40,
      "5": 10,
      "6": 41,
      "7": 11,
      "8": 42,
      "9": 13,
      "10": 43,
      "11": 14,
      "12": 44
    }
  },
  "1991": {
    "month": {
      "1": 15,
      "2": 46,
      "3": 14,
      "4": 45,
      "5": 15,
      "6": 46,
      "7": 16,
      "8": 47,
      "9": 18,
      "10": 48,
      "11": 19,
      "12": 49
    }
  },
  "1992": {
    "month": {
      "1": 20,
      "2": 51,
      "3": 20,
      "4": 51,
      "5": 21,
      "6": 52,
      "7": 22,
      "8": 53,
      "9": 24,
      "10": 54,
      "11": 25,
      "12": 55
    }
  },
  "1993": {
    "month": {
      "1": 26,
      "2": 57,
      "3": 25,
      "4": 56,
      "5": 26,
      "6": 57,
      "7": 27,
      "8": 58,
      "9": 29,
      "10": 59,
      "11": 30,
      "12": 60
    }
  },
  "1994": {
    "month": {
      "1": 31,
      "2": 62,
      "3": 30,
      "4": 61,
      "5": 31,
      "6": 62,
      "7": 32,
      "8": 63,
      "9": 34,
      "10": 64,
      "11": 35,
      "12": 65
    }
  },
  "1995": {
    "month": {
      "1": 36,
      "2": 67,
      "3": 35,
      "4": 66,
      "5": 36,
      "6": 67,
      "7": 37,
      "8": 8,
      "9": 39,
      "10": 9,
      "11": 40,
      "12": 10
    }
  },
  "1996": {
    "month": {
      "1": 41,
      "2": 12,
      "3": 41,
      "4": 12,
      "5": 42,
      "6": 13,
      "7": 43,
      "8": 14,
      "9": 45,
      "10": 15,
      "11": 46,
      "12": 16
    }
  },
  "1997": {
    "month": {
      "1": 47,
      "2": 18,
      "3": 46,
      "4": 17,
      "5": 47,
      "6": 18,
      "7": 48,
      "8": 19,
      "9": 50,
      "10": 20,
      "11": 51,
      "12": 21
    }
  },
  "1998": {
    "month": {
      "1": 52,
      "2": 23,
      "3": 51,
      "4": 22,
      "5": 52,
      "6": 23,
      "7": 53,
      "8": 24,
      "9": 55,
      "10": 24,
      "11": 26,
      "12": 26
    }
  },
  "1999": {
    "month": {
      "1": 57,
      "2": 28,
      "3": 56,
      "4": 27,
      "5": 57,
      "6": 28,
      "7": 58,
      "8": 29,
      "9": 60,
      "10": 30,
      "11": 61,
      "12": 31
    }
  },
  "2000": {
    "month": {
      "1": 62,
      "2": 33,
      "3": 62,
      "4": 33,
      "5": 63,
      "6": 34,
      "7": 64,
      "8": 35,
      "9": 66,
      "10": 36,
      "11": 67,
      "12": 37
    }
  },
  "2001": {
    "month": {
      "1": 68,
      "2": 39,
      "3": 67,
      "4": 38,
      "5": 68,
      "6": 39,
      "7": 9,
      "8": 40,
      "9": 11,
      "10": 41,
      "11": 12,
      "12": 42
    }
  },
  "2002": {
    "month": {
      "1": 13,
      "2": 44,
      "3": 12,
      "4": 43,
      "5": 13,
      "6": 44,
      "7": 14,
      "8": 45,
      "9": 16,
      "10": 46,
      "11": 17,
      "12": 47
    }
  },
  "2003": {
    "month": {
      "1": 18,
      "2": 50,
      "3": 17,
      "4": 48,
      "5": 18,
      "6": 49,
      "7": 19,
      "8": 50,
      "9": 21,
      "10": 51,
      "11": 22,
      "12": 52
    }
  },
  "2004": {
    "month": {
      "1": 23,
      "2": 54,
      "3": 23,
      "4": 54,
      "5": 24,
      "6": 55,
      "7": 25,
      "8": 56,
      "9": 27,
      "10": 57,
      "11": 28,
      "12": 58
    }
  },
  "2005": {
    "month": {
      "1": 29,
      "2": 60,
      "3": 28,
      "4": 59,
      "5": 29,
      "6": 60,
      "7": 30,
      "8": 61,
      "9": 32,
      "10": 62,
      "11": 33,
      "12": 63
    }
  },
  "2006": {
    "month": {
      "1": 34,
      "2": 65,
      "3": 33,
      "4": 64,
      "5": 34,
      "6": 65,
      "7": 35,
      "8": 66,
      "9": 37,
      "10": 67,
      "11": 38,
      "12": 68
    }
  },
  "2007": {
    "month": {
      "1": 39,
      "2": 10,
      "3": 38,
      "4": 9,
      "5": 39,
      "6": 10,
      "7": 40,
      "8": 11,
      "9": 42,
      "10": 12,
      "11": 43,
      "12": 13
    }
  },
  "2008": {
    "month": {
      "1": 44,
      "2": 15,
      "3": 44,
      "4": 15,
      "5": 45,
      "6": 16,
      "7": 46,
      "8": 17,
      "9": 48,
      "10": 18,
      "11": 49,
      "12": 19
    }
  },
  "2009": {
    "month": {
      "1": 50,
      "2": 21,
      "3": 49,
      "4": 20,
      "5": 50,
      "6": 21,
      "7": 51,
      "8": 22,
      "9": 53,
      "10": 23,
      "11": 54,
      "12": 24
    }
  },
  "2010": {
    "month": {
      "1": 55,
      "2": 26,
      "3": 54,
      "4": 25,
      "5": 55,
      "6": 26,
      "7": 56,
      "8": 27,
      "9": 58,
      "10": 28,
      "11": 59,
      "12": 29
    }
  },
  "2011": {
    "month": {
      "1": 60,
      "2": 31,
      "3": 59,
      "4": 30,
      "5": 60,
      "6": 31,
      "7": 61,
      "8": 32,
      "9": 63,
      "10": 33,
      "11": 64,
      "12": 34
    }
  },
  "2012": {
    "month": {
      "1": 65,
      "2": 36,
      "3": 65,
      "4": 36,
      "5": 66,
      "6": 37,
      "7": 67,
      "8": 38,
      "9": 9,
      "10": 39,
      "11": 10,
      "12": 40
    }
  },
  "2013": {
    "month": {
      "1": 11,
      "2": 42,
      "3": 10,
      "4": 41,
      "5": 11,
      "6": 42,
      "7": 12,
      "8": 43,
      "9": 14,
      "10": 44,
      "11": 15,
      "12": 45
    }
  },
  "2014": {
    "month": {
      "1": 16,
      "2": 47,
      "3": 15,
      "4": 46,
      "5": 16,
      "6": 47,
      "7": 17,
      "8": 48,
      "9": 19,
      "10": 49,
      "11": 20,
      "12": 50
    }
  },
  "2015": {
    "month": {
      "1": 21,
      "2": 52,
      "3": 20,
      "4": 51,
      "5": 21,
      "6": 52,
      "7": 22,
      "8": 53,
      "9": 24,
      "10": 54,
      "11": 25,
      "12": 55
    }
  },
  "2016": {
    "month": {
      "1": 26,
      "2": 57,
      "3": 26,
      "4": 57,
      "5": 27,
      "6": 58,
      "7": 28,
      "8": 59,
      "9": 30,
      "10": 60,
      "11": 31,
      "12": 61
    }
  },
  "2017": {
    "month": {
      "1": 32,
      "2": 63,
      "3": 31,
      "4": 62,
      "5": 32,
      "6": 63,
      "7": 33,
      "8": 64,
      "9": 35,
      "10": 65,
      "11": 36,
      "12": 66
    }
  },
  "2018": {
    "month": {
      "1": 37,
      "2": 68,
      "3": 36,
      "4": 67,
      "5": 37,
      "6": 68,
      "7": 38,
      "8": 9,
      "9": 40,
      "10": 10,
      "11": 41,
      "12": 11
    }
  },
  "2019": {
    "month": {
      "1": 42,
      "2": 13,
      "3": 41,
      "4": 12,
      "5": 42,
      "6": 13,
      "7": 43,
      "8": 14,
      "9": 45,
      "10": 15,
      "11": 46,
      "12": 16
    }
  },
  "2020": {
    "month": {
      "1": 47,
      "2": 18,
      "3": 47,
      "4": 18,
      "5": 48,
      "6": 19,
      "7": 49,
      "8": 20,
      "9": 51,
      "10": 21,
      "11": 52,
      "12": 22
    }
  },
  "2021": {
    "month": {
      "1": 53,
      "2": 24,
      "3": 52,
      "4": 23,
      "5": 53,
      "6": 24,
      "7": 54,
      "8": 25,
      "9": 56,
      "10": 26,
      "11": 57,
      "12": 27
    }
  },
  "2022": {
    "month": {
      "1": 58,
      "2": 29,
      "3": 57,
      "4": 28,
      "5": 58,
      "6": 29,
      "7": 59,
      "8": 30,
      "9": 61,
      "10": 31,
      "11": 62,
      "12": 32
    }
  },
  "2023": {
    "month": {
      "1": 63,
      "2": 34,
      "3": 62,
      "4": 33,
      "5": 63,
      "6": 34,
      "7": 64,
      "8": 35,
      "9": 66,
      "10": 36,
      "11": 67,
      "12": 37
    }
  },
  "2024": {
    "month": {
      "1": 68,
      "2": 39,
      "3": 68,
      "4": 39,
      "5": 9,
      "6": 40,
      "7": 10,
      "8": 41,
      "9": 12,
      "10": 42,
      "11": 13,
      "12": 43
    }
  },
  "2025": {
    "month": {
      "1": 14,
      "2": 45,
      "3": 13,
      "4": 44,
      "5": 14,
      "6": 45,
      "7": 15,
      "8": 46,
      "9": 17,
      "10": 47,
      "11": 18,
      "12": 48
    }
  },
  "2026": {
    "month": {
      "1": 19,
      "2": 50,
      "3": 18,
      "4": 49,
      "5": 19,
      "6": 50,
      "7": 20,
      "8": 51,
      "9": 22,
      "10": 52,
      "11": 23,
      "12": 53
    }
  },
  "2027": {
    "month": {
      "1": 24,
      "2": 55,
      "3": 23,
      "4": 54,
      "5": 24,
      "6": 55,
      "7": 25,
      "8": 56,
      "9": 27,
      "10": 57,
      "11": 28,
      "12": 58
    }
  },
  "2028": {
    "month": {
      "1": 29,
      "2": 60,
      "3": 29,
      "4": 60,
      "5": 30,
      "6": 61,
      "7": 31,
      "8": 62,
      "9": 33,
      "10": 63,
      "11": 34,
      "12": 64
    }
  },
  "2029": {
    "month": {
      "1": 35,
      "2": 66,
      "3": 34,
      "4": 65,
      "5": 35,
      "6": 66,
      "7": 36,
      "8": 67,
      "9": 38,
      "10": 68,
      "11": 39,
      "12": 9
    }
  },
  "2030": {
    "month": {
      "1": 40,
      "2": 11,
      "3": 39,
      "4": 10,
      "5": 40,
      "6": 11,
      "7": 41,
      "8": 12,
      "9": 43,
      "10": 13,
      "11": 44,
      "12": 14
    }
  },
  "2031": {
    "month": {
      "1": 45,
      "2": 16,
      "3": 44,
      "4": 15,
      "5": 45,
      "6": 16,
      "7": 46,
      "8": 17,
      "9": 48,
      "10": 18,
      "11": 49,
      "12": 19
    }
  },
  "2032": {
    "month": {
      "1": 50,
      "2": 21,
      "3": 50,
      "4": 21,
      "5": 51,
      "6": 22,
      "7": 52,
      "8": 23,
      "9": 54,
      "10": 24,
      "11": 55,
      "12": 25
    }
  },
  "2033": {
    "month": {
      "1": 56,
      "2": 27,
      "3": 55,
      "4": 26,
      "5": 56,
      "6": 27,
      "7": 57,
      "8": 28,
      "9": 59,
      "10": 29,
      "11": 60,
      "12": 30
    }
  },
  "2034": {
    "month": {
      "1": 61,
      "2": 32,
      "3": 60,
      "4": 31,
      "5": 61,
      "6": 32,
      "7": 62,
      "8": 33,
      "9": 64,
      "10": 34,
      "11": 65,
      "12": 35
    }
  },
  "2035": {
    "month": {
      "1": 66,
      "2": 37,
      "3": 65,
      "4": 36,
      "5": 66,
      "6": 37,
      "7": 67,
      "8": 38,
      "9": 9,
      "10": 39,
      "11": 10,
      "12": 40
    }
  },
  "2036": {
    "month": {
      "1": 11,
      "2": 42,
      "3": 11,
      "4": 42,
      "5": 12,
      "6": 43,
      "7": 13,
      "8": 44,
      "9": 15,
      "10": 45,
      "11": 16,
      "12": 46
    }
  },
  "2037": {
    "month": {
      "1": 17,
      "2": 48,
      "3": 16,
      "4": 47,
      "5": 17,
      "6": 48,
      "7": 18,
      "8": 49,
      "9": 20,
      "10": 50,
      "11": 21,
      "12": 51
    }
  },
  "2038": {
    "month": {
      "1": 22,
      "2": 53,
      "3": 21,
      "4": 52,
      "5": 22,
      "6": 53,
      "7": 23,
      "8": 54,
      "9": 25,
      "10": 55,
      "11": 26,
      "12": 56
    }
  },
  "2039": {
    "month": {
      "1": 27,
      "2": 58,
      "3": 26,
      "4": 57,
      "5": 27,
      "6": 58,
      "7": 28,
      "8": 59,
      "9": 30,
      "10": 60,
      "11": 31,
      "12": 61
    }
  },
  "2040": {
    "month": {
      "1": 32,
      "2": 63,
      "3": 32,
      "4": 63,
      "5": 33,
      "6": 64,
      "7": 34,
      "8": 65,
      "9": 36,
      "10": 66,
      "11": 37,
      "12": 67
    }
  },
  "2041": {
    "month": {
      "1": 38,
      "2": 9,
      "3": 37,
      "4": 68,
      "5": 38,
      "6": 9,
      "7": 39,
      "8": 20,
      "9": 41,
      "10": 11,
      "11": 42,
      "12": 12
    }
  }
}
